import * as React from 'react';
import { IgcIconComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * The icon component allows visualizing collections of pre-registered SVG icons.
 * @class
 */
export const IgrIcon = /* @__PURE__ */ createComponent({
  tagName: 'igc-icon',
  displayName: 'IgrIcon',
  elementClass: Component,
  react: React,
});

export type IgrIcon = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrIconModule = Component;
